import Joi from '@hapi/joi'

export const GreenleafCustomerSummaryReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("OperationEntityID").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Factory required`
    }),
    date: Joi.string().invalid("").label("Date").messages({
        "any.invalid": `Date required`,
    })
}